export default __webpack_public_path__ + "static/media/hashtag.b0aca5bc.svg";